import React, { useContext, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { Grid } from "@mui/material";
import httpRequest from "../../httpRequest";
import userContext from "../../context/user-context";
import AppLayout from "../../components/AppLayout/AppLayout";
import UsersTable from "../../components/UsersTable/UsersTable";
import { useStyles } from "./styles";

const UsersPage = () => {
  const classes = useStyles();
  const userCtx = useContext(userContext);
  const [usersData, setUsersData] = useState([]);
  const [updatedUser, setUpdatedUser] = useState({});
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
       

        // Fetch users data from backend
        const usersResp = await httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-users?exclude_fields=avatar,signature,employee`);
        const users = usersResp.data.users;
        
        

        setUsersData(users);
      } catch (error) {
        console.error("Error fetching users:", error);
        enqueueSnackbar("Error fetching users", { variant: "error" });
      }
    };

    fetchUserData();
  }, [updatedUser, enqueueSnackbar]);

  const handleUserUpdated = (updatedUserID, updatedUserRole) => {
    setUpdatedUser({ updatedUserID, updatedUserRole });
  };

  return (
    <AppLayout userName={userCtx.userName}>
      <Grid container>
        <div className={classes.table}>
          <UsersTable users={usersData} onUserUpdated={handleUserUpdated} />
        </div>
      </Grid>
    </AppLayout>
  );
};

export default UsersPage;
